/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Личные данные пользователя профиля
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
  /**
   * UUID пользователя
   * @type {string}
   * @memberof UserProfile
   */
  uuid: string
  /**
   * Имя
   * @type {string}
   * @memberof UserProfile
   */
  name: string
  /**
   * Email
   * @type {string}
   * @memberof UserProfile
   */
  email: string
  /**
   * Телефон
   * @type {string}
   * @memberof UserProfile
   */
  phone: string
  /**
   * Фамилия
   * @type {string}
   * @memberof UserProfile
   */
  lastname?: string | null
  /**
   * Отчество
   * @type {string}
   * @memberof UserProfile
   */
  patronymic?: string | null
}

/**
 * Check if a given object implements the UserProfile interface.
 */
export function instanceOfUserProfile(value: object): value is UserProfile {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('email' in value) || value['email'] === undefined) return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  return true
}

export function UserProfileFromJSON(json: any): UserProfile {
  return UserProfileFromJSONTyped(json, false)
}

export function UserProfileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserProfile {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    email: json['email'],
    phone: json['phone'],
    lastname: json['lastname'] == null ? undefined : json['lastname'],
    patronymic: json['patronymic'] == null ? undefined : json['patronymic'],
  }
}

export function UserProfileToJSON(value?: UserProfile | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    email: value['email'],
    phone: value['phone'],
    lastname: value['lastname'],
    patronymic: value['patronymic'],
  }
}
